import React from 'react';
import { Typography } from '@cp/ds/src/components/typography';
import { RoutedLink } from 'src/shared/ui/link';
import { withTrackClick } from 'src/shared/tracking';
import { DialogEvents } from '../../events';

const Link = withTrackClick(RoutedLink, DialogEvents.DialogListViewAll);

export interface DialogShowAllLinkProps {
  href: string;
}

export const DialogShowAllLink: React.FC<DialogShowAllLinkProps> = ({ href }) => {
  return (
    <Link href={href} underline={false}>
      <Typography variant="body bold">Показать все</Typography>
    </Link>
  );
};
